/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CardNumber = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21.412 15.626C22.252 15.626 22.9 16.13 22.9 16.802C22.9 17.24 22.612 17.66 22.21 17.762C22.5439 17.7986 22.8142 18.0038 22.9535 18.3007L23.0004 18.4192C23.0366 18.5294 23.056 18.6494 23.056 18.776C23.056 18.8985 23.037 19.0154 23.001 19.1252L23 19.582L22.9997 19.1291C22.8174 19.6783 22.2098 20.048 21.436 20.048C20.554 20.048 19.81 19.52 19.81 18.602H20.764C20.764 18.986 21.046 19.232 21.436 19.232C21.826 19.232 22.108 19.022 22.108 18.698C22.108 18.338 21.82 18.158 21.4 18.158H21.094V17.408H21.322C21.712 17.408 21.952 17.156 21.952 16.886C21.952 16.64 21.73 16.436 21.412 16.436C21.064 16.436 20.8 16.67 20.806 17.006H19.87C19.864 16.262 20.524 15.626 21.412 15.626ZM23 4V14H21.5V10.5H2.5V18.5L11.999 18.5V20H1V4H23ZM14.712 15.674V20H13.782V17.09H12.834V16.4C13.494 16.388 13.872 16.172 13.998 15.674H14.712ZM17.342 15.626C18.284 15.626 18.908 16.196 18.908 17.018C18.908 17.524 18.6257 17.9745 18.024 18.4759L17.126 19.184H18.902V20H15.8V19.238L17.306 17.99C17.756 17.612 17.96 17.324 17.96 17.018C17.96 16.67 17.708 16.436 17.342 16.436C16.91 16.436 16.658 16.796 16.7 17.324H15.8C15.71 16.346 16.424 15.626 17.342 15.626ZM10 15.5V17H4V15.5H10ZM21.5 5.5H2.5V8H21.5V5.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
